import * as React from 'react';

import {
  UXFB_ACTION_OPEN,
  UXFB_CLIENT_EVENTS_CONFIG_KEY,
  UXFB_EVENT_ZHK_CATALOG,
  UXFB_PLATFORM,
} from '../../constants/uxfb';
import { useApplicationContext } from '../../utils/applicationContext';
import { sendUXSEventWhenReady } from '../../utils/uxs';

/**
 * Шлёт UXFB-событие `zhk_catalog` с `action: open` один раз при заходе в каталог ЖК (mount).
 *
 * `dedupeKey` обязателен: useRef не переживает ремаунт контейнера, дубль события засчитывается
 * бэкендом UXFB как лишний «заход», и кампании «на 2-й заход» выезжают уже на первом.
 */
export function useOpenZhkCatalogUxfbEvent(): void {
  const { config } = useApplicationContext();

  React.useEffect(() => {
    if (config.get<boolean>(UXFB_CLIENT_EVENTS_CONFIG_KEY) === false) {
      return;
    }

    sendUXSEventWhenReady(
      UXFB_EVENT_ZHK_CATALOG,
      { platform: UXFB_PLATFORM, action: UXFB_ACTION_OPEN },
      { dedupeKey: `${UXFB_EVENT_ZHK_CATALOG}:${UXFB_ACTION_OPEN}` },
    );
  }, [config]);
}
